<mat-card class="mat-elevation-z2">
  <mat-card-content>
    <h1>Repositorio</h1>
    <a href="https://github.com/MartinFreire/angular-multi-level-form" target="_blank">
      <button mat-mini-fab color="primary">
        <mat-icon color="accent">code</mat-icon>
      </button>
    </a>

    <div style="margin: 64px 16px 16px 16px;" fxLayout="column" fxLayoutGap="32px">
      <p [routerLink]="['/example1']">Ejemplo 1</p>
      <p [routerLink]="['/example2']">Ejemplo 2</p>
      <p [routerLink]="['/example3']">Ejemplo 3</p>
    </div>
  </mat-card-content>
</mat-card>
